import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatVolume } from './WhaleTradesPanel';

const COINS = ['BTC', 'ETH', 'SOL'];

function LiquidationsPanel({ liquidationSummary, coinStats, hours }) {
  const { t } = useTranslation();
  // In liquidations: longVolume = long positions liquidated, shortVolume = short positions liquidated
  const totalLongLiq = liquidationSummary?.longVolume || 0;
  const totalShortLiq = liquidationSummary?.shortVolume || 0;
  const totalAll = totalLongLiq + totalShortLiq || 1;

  const longPct = (totalLongLiq / totalAll) * 100;
  const shortPct = (totalShortLiq / totalAll) * 100;

  // Build coin rows — use coinStats long/short as proxy for per-coin liq split
  const coinRows = COINS.map((coin) => {
    const s = coinStats?.[coin];
    return {
      coin,
      long: s?.long || 0,
      short: s?.short || 0,
      total: (s?.long || 0) + (s?.short || 0),
    };
  });

  const maxCoinTotal = coinRows.reduce((m, c) => Math.max(m, c.total), 1);

  return (
    <div className="stats-panel stats-liq-panel">
      <div className="stats-panel-header">
        <span className="stats-panel-title">
          {hours}h {t('stats.liquidations')}
        </span>
      </div>

      <div className="stats-blk-total">
        <div>
          <div className="stats-lbl">{t('stats.total')}</div>
          <div className="stats-bt-val">{formatVolume(totalLongLiq + totalShortLiq)}</div>
        </div>
        <div className="stats-bt-split">
          <div className="stats-bts-row">
            <span className="stats-bts-lbl c-red">{t('stats.long')}</span>
            <div className="stats-bts-track">
              <div
                className="stats-bts-fill"
                style={{ width: `${longPct}%`, background: 'var(--red, #ef4444)', opacity: 0.65 }}
              />
            </div>
            <span className="stats-bts-num c-red">{formatVolume(totalLongLiq)}</span>
          </div>
          <div className="stats-bts-row">
            <span className="stats-bts-lbl c-green">{t('stats.short')}</span>
            <div className="stats-bts-track">
              <div
                className="stats-bts-fill"
                style={{ width: `${shortPct}%`, background: 'var(--green, #22c55e)', opacity: 0.65 }}
              />
            </div>
            <span className="stats-bts-num c-green">{formatVolume(totalShortLiq)}</span>
          </div>
        </div>
      </div>

      <div className="stats-coin-list">
        {coinRows.map((row) => {
          const lPct = (row.long / maxCoinTotal) * 100;
          const sPct = (row.short / maxCoinTotal) * 100;
          return (
            <div key={row.coin} className="stats-coin-row">
              <span className="stats-coin-nm">{row.coin}</span>
              <div className="stats-coin-bars">
                <div className="stats-cb-row">
                  <span className="stats-cb-lbl liq-l">L</span>
                  <div className="stats-cb-track">
                    <div className="stats-cb-fill liq-l" style={{ width: `${lPct}%` }} />
                  </div>
                  <span className="stats-cb-num">{formatVolume(row.long)}</span>
                </div>
                <div className="stats-cb-row">
                  <span className="stats-cb-lbl liq-s">S</span>
                  <div className="stats-cb-track">
                    <div className="stats-cb-fill liq-s" style={{ width: `${sPct}%` }} />
                  </div>
                  <span className="stats-cb-num">{formatVolume(row.short)}</span>
                </div>
              </div>
              <span className="stats-coin-tot">{formatVolume(row.total)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LiquidationsPanel;
